import { render } from "./AgeStep.vue?vue&type=template&id=08cdf5f9&ts=true"
import script from "./AgeStep.vue?vue&type=script&lang=ts"
export * from "./AgeStep.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/tawa.digital.dashboard/tawa.digital.dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__